"use client"

import { Milestone } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MilestoneIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MilestoneIcon = component(Icon)({ as: Milestone })
